// Registrations.js — SÜPER ADMIN: TESCİL ARAMASI (adım 4d, 30 Eyl 2026)
//
// 🔑 Serkan (30 Eyl): *"Bir de tescil arama modülü yapalım"* · *"Bizimle çalışmış çalışan bütün
//    tesciller (farklı şirketlerde olsa) görünür"* · *"O tescil belki daha önce başka bir uçak
//    olarak kayıtlarda olabilir; bazen tescil belirli bir zaman sonra iptal ediliyor, başka uçağa
//    veriliyor."*
// Veri tek istekte, veritabanı fonksiyonundan: `tescil_gecmisi()` (20260930g) — yalnız süper
// admin çağırır; satır = TESCİL + ŞİRKET + TİP (uçak kaydı + iPad arşivi + PAPER OFP).
// Aynı tescilin birden çok satırı varsa (başka şirket, başka tip) satırda söylenir — onay
// vermeden önce görülmesi gereken tam da budur.
import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import HarfliGiris from './HarfliGiris';
import { utcGun } from '../utcTarih';

const C = {
  bg3:'var(--bg3)', border:'var(--border)', t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)',
  accent:'var(--accent)', red:'var(--red)', green:'var(--green)', amber:'var(--amber)',
};
const kutu = { width:'100%', boxSizing:'border-box', background:C.bg3, color:C.t1,
               border:`1px solid ${C.border}`, borderRadius:4, padding:'7px 9px',
               fontSize:12, fontFamily:'var(--mono)' };
const etiket = { display:'block', fontSize:9, color:C.t3, fontWeight:700, letterSpacing:1, marginBottom:4 };
const th = { textAlign:'left', padding:'7px 10px', fontSize:9, color:C.t3, fontWeight:700,
             letterSpacing:1, borderBottom:`1px solid ${C.border}`, whiteSpace:'nowrap' };
const td = { padding:'7px 10px', fontSize:12, color:C.t1, borderBottom:`1px solid ${C.border}`,
             fontFamily:'var(--mono)', verticalAlign:'top' };
const rozet = renk => ({ display:'inline-block', padding:'1px 6px', fontSize:9, fontWeight:700, letterSpacing:1,
                         borderRadius:3, color:renk, border:`1px solid ${renk}` });

// Tescil eşleşmesi tire/boşluk/harf büyüklüğü farkını saymaz — veritabanı fonksiyonu ile AYNI kural.
export const tescilAnahtari = v => String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

/** Satırın durumu: uçak kaydı filoda / filodan çıkarılmış / yalnız uçuş kaydında. */
export function tescilDurumu(r) {
  if (r.ucak_kaydi && r.filoda) return { metin: 'IN FLEET', renk: C.green };
  if (r.ucak_kaydi) return { metin: 'RETIRED', renk: C.t3 };
  return { metin: 'FLIGHT RECORDS ONLY', renk: C.amber };
}

export default function Registrations() {
  const [veri, setVeri] = useState({ satirlar: [], hata: null, yuklendi: false });
  const [sorgu, setSorgu] = useState('');

  useEffect(() => {
    let iptal = false;
    supabase.rpc('tescil_gecmisi').then(({ data, error }) => {
      if (iptal) return;
      setVeri({ satirlar: data || [], hata: error ? error.message : null, yuklendi: true });
    });
    return () => { iptal = true; };
  }, []);

  const { satirlar, hata, yuklendi } = veri;
  // Aynı tescilin kaç satırı var (şirket ya da tip farkı).
  const satirSayisi = {};
  satirlar.forEach(r => { satirSayisi[r.anahtar] = (satirSayisi[r.anahtar] || 0) + 1; });
  const q = tescilAnahtari(sorgu);
  const gorunen = q ? satirlar.filter(r => r.anahtar.includes(q)) : satirlar;

  return (
    <div style={{ flex:1, overflowY:'auto', padding:18, minWidth:0 }}>
      {!yuklendi && <div style={{ fontSize:10, color:C.t3 }}>LOADING...</div>}
      {yuklendi && hata && (
        <div data-testid="tescil-hata" style={{ fontSize:12, color:C.red, fontWeight:700 }}>
          REGISTRATIONS NOT READ — {hata}
        </div>
      )}
      {yuklendi && !hata && (
        <>
          <div data-testid="tescil-ozet" style={{ fontSize:11, color:C.t2, marginBottom:14, lineHeight:1.7 }}>
            {Object.keys(satirSayisi).length} registrations · {satirlar.length} records
            <div style={{ fontSize:10, color:C.t3 }}>
              Every registration that has worked with us, in every company: aircraft records (in the fleet or
              retired) and flown flights — iPad archive and PAPER OFP; voided flights and plans never flown are
              not counted. One row per registration, company and type, so a registration that was another
              aircraft before shows as more than one row.
            </div>
          </div>
          <label style={etiket}>SEARCH REGISTRATION</label>
          <HarfliGiris style={{ ...kutu, maxWidth:300 }} data-testid="tescil-arama" value={sorgu}
                       placeholder="TC-REC" onChange={setSorgu} />
          <div style={{ marginTop:12 }}>
            {gorunen.length === 0
              ? <div data-testid="tescil-yok" style={{ fontSize:11, color:C.t2 }}>
                  {q ? `No record of ${sorgu} — this registration has not worked with us.` : 'No registrations recorded yet.'}
                </div>
              : (
                <table style={{ width:'100%', borderCollapse:'collapse' }} data-testid="tescil-tablo">
                  <thead><tr>{['REGISTRATION','COMPANY','TYPE','STATUS','FIRST FLIGHT','LAST FLIGHT','EFB FLIGHTS','PAPER OFP'].map(h =>
                    <th key={h} style={th}>{h}</th>)}</tr></thead>
                  <tbody>{gorunen.map(r => {
                    const d = tescilDurumu(r);
                    const n = satirSayisi[r.anahtar];
                    return (
                      <tr key={`${r.anahtar}|${r.customer_id}|${r.tip}`}>
                        <td style={{ ...td, color:C.accent, fontWeight:700 }}>
                          {r.tescil}
                          {/* Rozet tescilin ALTINDA (30 Eyl: yanına yapışıyordu — rozet inline-block, kendi satırı yoktu). */}
                          {n > 1 && <div style={{ marginTop:4 }}><span data-testid="tescil-coklu" style={rozet(C.amber)}>{n} RECORDS</span></div>}
                        </td>
                        <td style={td}>{r.sirket || '—'}</td>
                        <td style={td}>{r.tip || '—'}</td>
                        <td style={td}><span style={rozet(d.renk)}>{d.metin}</span></td>
                        <td style={td}>{utcGun(r.ilk_ucus)}</td>
                        <td style={td}>{utcGun(r.son_ucus)}</td>
                        <td style={td}>{r.efb_ucus}</td>
                        <td style={td}>{r.kagit_ucus}</td>
                      </tr>
                    );
                  })}</tbody>
                </table>
              )}
          </div>
        </>
      )}
    </div>
  );
}
